import checkScroll from "../onCheckScrollListener";

/**
 * Sets up scroll event listener for the customizer pages
 * @returns cleanup function to remove event listener
 */
export function initializeScrollListener(): () => void {
	const handleScroll = () => {
		checkScroll();
	};

	window.addEventListener("scroll", handleScroll);

	// Return cleanup function
	return () => {
		window.removeEventListener("scroll", handleScroll);
	};
}

/**
 * Alternative version that accepts a custom scroll handler
 * @param scrollHandler - Custom scroll handler function
 * @returns cleanup function to remove event listener
 */
export function initializeCustomScrollListener(scrollHandler: () => void): () => void {
	window.addEventListener("scroll", scrollHandler);

	return () => {
		window.removeEventListener("scroll", scrollHandler);
	};
}
